import LocalConsoleOverview from './pages/LocalConsoleOverview';
import OfflineModeSection from './pages/OfflineMode';
import type { LocalConsoleRoute } from './types';

export const LOCAL_CONSOLE_ROUTES: LocalConsoleRoute[] = [
  {
    id: 'overview',
    label: 'Overview',
    Component: LocalConsoleOverview,
  },
  {
    id: 'offline-mode',
    label: 'Offline Mode',
    Component: OfflineModeSection,
  },
];

export const OFFLINE_MODE_ROUTE_ID = 'offline-mode';

export function findLocalConsoleRoute(
  routeId: string,
  routes: LocalConsoleRoute[] = LOCAL_CONSOLE_ROUTES
): LocalConsoleRoute {
  return routes.find((route) => route.id === routeId) ?? routes[0];
}

export default LOCAL_CONSOLE_ROUTES;
